/** Fetch a video or clip that this hall is allowed to play on its TV. */

export async function fetchHallTvMedia({ hallSlug, videoId, clipId, t } = {}) {
  const params = new URLSearchParams();
  if (clipId != null && clipId !== '') params.set('clipId', String(clipId));
  if (videoId != null && videoId !== '') params.set('videoId', String(videoId));
  const moment = Math.max(0, Math.floor(Number(t) || 0));
  if (moment > 0) params.set('t', String(moment));

  const slug = encodeURIComponent(hallSlug || 'commons');
  const response = await fetch(`/api/halls/${slug}/tv-media?${params.toString()}`, {
    credentials: 'include'
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (response.status === 403) {
    return {
      blocked: true,
      error: data?.error || 'This video isn’t in this hall'
    };
  }
  if (!response.ok || !data?.video) {
    return {
      blocked: true,
      error: data?.error || 'Could not load that video'
    };
  }
  return {
    blocked: false,
    video: data.video,
    clip: data.clip || null,
    momentSeconds: Math.max(0, Math.floor(Number(data.momentSeconds) || 0))
  };
}
